import { GenericKeyValueType } from '../../interfaces/generics';
import { HevoEntityMeta } from '../../interfaces/entity-meta';

export const HEVO_ENTITY_META_DISPLAY_LABELS: Partial<
  GenericKeyValueType<keyof HevoEntityMeta, string>
> = {
  createdAt: 'Created at',
  createdBy: 'Created by',
  updatedAt: 'Updated at',
  updatedBy: 'Updated by'
};
